// extracted by mini-css-extract-plugin
module.exports = {"KeyWordSearch":"KeyWordSearch_KeyWordSearch__2mk3H","Text":"KeyWordSearch_Text__2NNUV","Link":"KeyWordSearch_Link__6LH73"};